import React, { useState, useEffect } from 'react'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header'
import qs from 'qs';
import './PickingEstateDetail.scss'
import ItemSKU from '../../components/shared/ItemSKU';
import { useParams, useLocation } from 'react-router-dom';
import pickingStateAPI from '../../api/PickingEstateAPI';
import { useDispatch } from 'react-redux';
import { loadingActions } from '../../redux/actions';
import moment from 'moment';
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const PickingEstateDetail = () => {

  const dispatch = useDispatch();
  const [modalSession, setModalSession] = useState(false)
  const [ocDetail, setOcDetail] = useState({})
  const params = useParams();
  const location = useLocation();
  console.log('QS PARSE:', qs.parse(location.search, { ignoreQueryPrefix: true }));
  const { storeId } = qs.parse(location.search, { ignoreQueryPrefix: true })
  const orderNumber = params.id;


  useEffect(() => {
    fetchOcDetail()
    // eslint-disable-next-line
  }, [])

  const fetchOcDetail = async () => {
    try {
      dispatch(loadingActions.setLoading(true))
      const data = await pickingStateAPI.getOCDetail(orderNumber, storeId);
      console.log(data);
      setOcDetail(data)
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      }
    }
  }

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      <div className='picking-state-detail-container'>
        <Header
          title='Picking / Reporte de pedidos'
          subtitle={`O. Compra N° ${orderNumber}`}
        // onClickBtn1={() => console.log('object')}
        // iconBtn1={ExcelIcon}
        // btnTitle1='Exportar'
        // btnTitle2='Enviar'
        // onClickBtn2={() => console.log('object')}
        // iconBtn2={SendIcon}
        />
        <div className='picking-state-detail-subheader'>
          <div className='picking-state-detail-subheader-title'>
            Fecha de Despacho: <span style={{ fontWeight: 500 }}>{moment.utc(ocDetail.compromiseDate).format('DD MMM YYYY')}</span>
          </div>
          <div className='picking-state-detail-subheader-row'>
            <div className='picking-state-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_papper-check.svg')} alt='pappercheck' />
              <span>Ticket N° <span style={{ fontWeight: 500 }}>{ocDetail.ticket}</span></span>
            </div>
            <div className='picking-state-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_store.svg')} alt='store-gray' />
              <span style={{ color: '#7C3F88' }}>Sucursal: {ocDetail.name}</span>
            </div>
            {/* <div className='picking-state-detail-subheader-row-item'>
              <img src={require('../../../assets/icons/ic_purchase.svg')} alt='store-gray'/>
              <span style={{color:'#F15B5B'}}>Picker: Carlos Pacheco -- DNI <span style={{fontWeight:500}}>44080622</span></span>
            </div> */}
          </div>
        </div>
        <div className='picking-state-detail-body'>
          <div className='picking-state-detail-body-title'>
            <div className='picking-state-detail-body-title-column'>
              <span>Cliente</span>
              <div className='picking-state-detail-body-title-column-detail'>
                <img src={require('../../../assets/icons/ic_cliente.svg')} alt='cliente' />
                <div>
                  <span>{ocDetail.clientName}</span>
                  <span>DNI {ocDetail.clientDni}</span>
                </div>
              </div>
            </div>
            {/* <div className='picking-state-detail-body-title-column'>
              <span>Picker</span>
              <div className='picking-state-detail-body-title-column-detail'>
                <img src={require('../../../assets/icons/ic_picker-alt.svg')} />
                <div>
                  <span>Manuel Rodrigo Campodónico del Carpio</span>
                  {console.log(ocDetail, 'OCDETAILLLLLLLLLL')}
                  {ocDetail.cuds && console.log(ocDetail.cuds[0], 'OCDETIALCUDS')}
                  <span>DNI {ocDetail.cuds && (ocDetail.cuds.length > 0 && ocDetail.cuds.find(c => c.pickerDni)?.pickerDni)}</span>
                </div>
              </div>
            </div> */}
          </div>
          { ocDetail.cuds?.filter(c => c.status === 'completed' || c.status === 'completedwithimp').length > 0 &&
            <div className='picking-state-detail-body-subtitle'>
              <span>Productos pickeados ({ocDetail.cuds?.filter(c => c.status === 'completed' || c.status === 'completedwithimp').length})</span>
              <div className='picking-state-detail-body-subtitle-items'>
                {ocDetail.cuds?.filter(c => c.status === 'completed' || c.status === 'completedwithimp').map(c => (
                  <ItemSKU
                    sku={c.sku}
                    cud={c.cud}
                    quantity={c.quantity}
                    brand={c.brand}
                    description={c.description}
                    price={c.price}
                    clientDni={ocDetail.clientDni}
                    pickerDni={c.pickerDni}
                  />
                ))}
              </div>
            </div>
          }
          {ocDetail.cuds?.filter(c => c.status === 'observed').length > 0 &&
            <div className='picking-state-detail-body-subtitle rejected'>
              <span>Productos rechazados ({ocDetail.cuds?.filter(c => c.status === 'observed').length})</span>
              <div className='picking-state-detail-body-subtitle-items'>
                {ocDetail.cuds?.filter(c => c.status === 'observed').map(c => (
                  <ItemSKU
                    sku={c.sku}
                    cud={c.cud}
                    quantity={c.quantity}
                    brand={c.brand}
                    description={c.description}
                    price={c.price}
                    clientDni={ocDetail.clientDni}
                    pickerDni={c.pickerDni}
                    obs={c.name}
                  />
                ))}
              </div>
            </div>
          }
          {ocDetail.cuds?.filter(c => c.status === 'pending' || c.status === 'assigned').length > 0 &&
            <div className='picking-state-detail-body-subtitle rest'>
              <span>Productos pendientes ({ocDetail.cuds?.filter(c => c.status === 'pending' || c.status === 'assigned').length})</span>
              <div className='picking-state-detail-body-subtitle-items'>
                {ocDetail.cuds?.filter(c => c.status === 'pending' || c.status === 'assigned').map(c => (
                  <ItemSKU
                    sku={c.sku}
                    cud={c.cud}
                    quantity={c.quantity}
                    brand={c.brand}
                    description={c.description}
                    price={c.price}
                    clientDni={ocDetail.clientDni}
                    pickerDni={c.pickerDni}
                  />
                ))}
              </div>
            </div>
          }
        </div>
      </div>
    </Layout>
  )
}

export default PickingEstateDetail
